export interface StationUpdateSignalRItem {
  /**
   * The station's id.
   *
   * The hub renamed this field. It was `stationId` until BE SCRUM-1047
   * (2026-07-27, "unify Crysberg telemetry realtime events"), which replaced
   * the payload with `StateRealtimeItem(int Id, int Status)` — so the wire now
   * says `id`. Both names are declared because environments can run different
   * BE builds; read the value through `stationUpdateItemId` rather than
   * picking a field, so a screen keeps working either way.
   */
  id?: number
  /** @deprecated Pre-SCRUM-1047 name for `id`. Read via `stationUpdateItemId`. */
  stationId?: number
  // 0-based StationState: 0=Inactive, 1=Idling, 2=WaitSchedule, 3=WaitStart,
  // 4=Started, 5=WaitStop, 6=Soaking, 7=Error, 8=RainSoaking.
  status: number
}

export interface StationUpdateSignalR {
  interfaceId: number
  items: StationUpdateSignalRItem[]
}

/** The station id a StationUpdate item carries, under either field name. */
export const stationUpdateItemId = (item: StationUpdateSignalRItem) =>
  Number(item.id ?? item.stationId)
